import React from 'react'
import styled from '@emotion/styled'
import { Card } from 'antd'
import { PortalArticleProblem } from '../helpers/artigo-validation'

interface PortalArticleProblemsPanelProps {
  problems: PortalArticleProblem[]
  onProblemClick: (problem: PortalArticleProblem) => void
}

export function PortalArticleProblemsPanel({
  problems,
  onProblemClick,
}: PortalArticleProblemsPanelProps) {
  if (problems.length === 0) return null

  return (
    <Card size="small" title={`Problemas (${problems.length})`}>
      <ProblemsList>
        {problems.map((problem, index) => {
          const isNavigable =
            typeof problem.blockIndex === 'number' ||
            Boolean(problem.field) ||
            problem.targetType === 'faq' ||
            problem.targetType === 'cta' ||
            problem.targetType === 'courses'

          return (
            <ProblemItem key={`${problem.path || problem.message}-${index}`}>
              <ProblemButton
                type="button"
                disabled={!isNavigable}
                onClick={() => isNavigable && onProblemClick(problem)}
              >
                <SeverityDot className={problem.severity} />
                <ProblemMessage>{problem.message}</ProblemMessage>
              </ProblemButton>
            </ProblemItem>
          )
        })}
      </ProblemsList>
    </Card>
  )
}

const ProblemsList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-height: 260px;
  margin: 0;
  padding: 0;
  overflow-y: auto;
  list-style: none;
`

const ProblemItem = styled.li`
  margin: 0;
`

const ProblemButton = styled.button`
  display: flex;
  width: 100%;
  align-items: flex-start;
  gap: 8px;
  border: 0;
  border-radius: 4px;
  padding: 6px 8px;
  background: transparent;
  color: #262626;
  text-align: left;
  cursor: pointer;

  &:hover:not(:disabled) {
    background: #fff7e6;
  }

  &:disabled {
    cursor: default;
  }
`

const SeverityDot = styled.span`
  flex: 0 0 auto;
  width: 8px;
  height: 8px;
  margin-top: 7px;
  border-radius: 50%;
  background: #faad14;

  &.erro {
    background: #ff4d4f;
  }
`

const ProblemMessage = styled.span`
  line-height: 1.4;
`
